import Alerts from './alerts'
import App from './app'
import Avatars from './avatars'
import BottomNav from './bottom-nav'
import Breadcrumbs from './breadcrumbs'
import Buttons from './buttons'
import Cards from './cards'
import Carousel from './carousel'
import Chips from './chips'
import DateTime from './pickers'
import Dialogs from './dialogs'
import Dividers from './dividers'
import ExpansionPanel from './expansion-panel'
import Footer from './footer'
import Grid from './grid'
import Icons from './icons'
import Lists from './lists'
import Menu from './menus'
import NavigationDrawer from './navigation-drawer'
import Toolbar from './toolbar'
import Pagination from './pagination'
import Parallax from './parallax'
import Progress from './progress'
import Select from './selects'
import SelectionControls from './selection-controls'
import Slider from './sliders'
import Subheader from './subheaders'
import Stepper from './steppers'
import Tables from './tables'
import Tabs from './tabs'
import TextFields from './text-fields'
import Transitions from './transitions'
import Snackbar from './snackbars'

export default Object.assign({},
  Alerts,
  App,
  Avatars,
  BottomNav,
  Breadcrumbs,
  Buttons,
  Cards,
  Carousel,
  Chips,
  DateTime,
  Dialogs,
  Dividers,
  ExpansionPanel,
  Footer,
  Grid,
  Icons,
  Lists,
  Menu,
  NavigationDrawer,
  Toolbar,
  Pagination,
  Parallax,
  Progress,
  Select,
  SelectionControls,
  Slider,
  Subheader,
  Stepper,
  Tables,
  Tabs,
  TextFields,
  Transitions,
  Snackbar
)



// WEBPACK FOOTER //
// ./src/components/index.js